export default __webpack_public_path__ + "static/media/Error-bro.42a2ac22.png";